/* INICIO ANGULAR */
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  registerLocaleData,
} from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import locale from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";

/* FIM ANGULAR */

/* INICIO ANGULAR MATERIAL */

import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";

import { BsModalService, ModalModule } from "ngx-bootstrap/modal";

import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
} from "@angular/material-moment-adapter";

// https://github.com/text-mask/text-mask/tree/master/angular2
import { TextMaskModule } from "angular2-text-mask";

// https://www.npmjs.com/package/ngx-mask
import { IConfig, NgxMaskModule } from "ngx-mask";
export const NgxMaskModule_options:
  | Partial<IConfig>
  | (() => Partial<IConfig>) = null;

// https://www.npmjs.com/package/ngx-currency
import { NgxCurrencyModule } from "ngx-currency";

export const customCurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true,
  min: null,
  max: null,
  //inputMode: CurrencyMaskInputMode.FINANCIAL
};

// https://github.com/mattlewis92/angular-confirmation-popover
import { ConfirmationPopoverModule } from "angular-confirmation-popover";

import { NgSelectModule } from "@ng-select/ng-select";
import {
  NgxUiLoaderConfig,
  NgxUiLoaderModule,
  NgxUiLoaderRouterModule,
} from "ngx-ui-loader";

import { MarkdownModule } from "ngx-markdown";

//https://www.npmjs.com/package/@fortawesome/angular-fontawesome
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

/* FIM TERCEIRO */

import { AppComponent } from "./app.component";

registerLocaleData(locale);

import { MatTooltipModule } from "@angular/material/tooltip";
import { QRCodeModule } from "angularx-qrcode";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { CookieService } from "ngx-cookie-service";
import { QuillModule } from "ngx-quill";
import { AppRoutingModule } from "./app-routing.module";
import { AdminFiduciProofComponent } from "./components/admin-fiduci-proof/admin-fiduci-proof.component";
import { AnnotationComponent } from "./components/annotation/annotation.component";
import { AttachmentComponent } from "./components/attachment/attachment.component";
import { AuthInterceptor } from "./components/auth/auth.interceptor";
import { EsqueciSenhaComponent } from "./components/auth/esqueci-senha/esqueci-senha.component";
import { LoginComponent } from "./components/auth/login/login.component";
import { PasswordResetComponent } from "./components/auth/password-reset/password-reset.component";
import { BankComponent } from "./components/banco/banco.component";
import { BankListComponent } from "./components/bank-list/bank-list.component";
import { BankRegisterComponent } from "./components/bank-register/bank-register.component";
import { BatchEmailComponent } from "./components/batch-email/batch-email.component";
import { CadastroUsuarioComponent } from "./components/cadastro-usuario/cadastro-usuario.component";
import { CalendarioComponent } from "./components/calendario/calendario.component";
import { CetipComponent } from "./components/cetip/cetip.component";
import { CompromissadaCompraComponent } from "./components/compromissada-compra/compromissada-compra.component";
import { CotaComponent } from "./components/cota/cota.component";
import { CounterpartListComponent } from "./components/counterpart-list/counterpart-list.component";
import { CounterpartRegisterComponent } from "./components/counterpart-register/counterpart-register.component";
import { CounterpartComponent } from "./components/counterpart/counterpart.component";
import { CutoffCreateComponent } from "./components/cutoff/cutoff-create/cutoff-create.component";
import { CutoffDefaultManagerFundDialogComponent } from "./components/cutoff/cutoff-default-manager-fund-dialog/cutoff-default-manager-fund-dialog.component";
import { CutoffDefaultUpdateComponent } from "./components/cutoff/cutoff-default-update/cutoff-default-update.component";
import { CutoffExceptionHistoryComponent } from "./components/cutoff/cutoff-exception-history/cutoff-exception-history.component";
import { CutoffComponent } from "./components/cutoff/cutoff.component";
import { DadosBoletaComponent } from "./components/dados-boleta/dados-boleta.component";
import { DadosFundoComponent } from "./components/dados-fundo/dados-fundo.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ExchangeComponent } from "./components/exchange/exchange.component";
import { ExpenseTypeComponent } from "./components/expense-type/expense-type.component";
import { ExpensesComponent } from "./components/expenses/expenses.component";
import { FavoredComponent } from "./components/favored/favored.component";
import { FuturosComponent } from "./components/futuros/futuros.component";
import { CadastroGrupoComponent } from "./components/grupos/cadastro.component";
import { GruposComponent } from "./components/grupos/grupos.component";
import { FooterComponent } from "./components/home/footer/footer.component";
import { HomeComponent } from "./components/home/home.component";
import { CambioErrorComponent } from "./components/infrastructure/cambio-error/cambio-error.component";
import { CargaErrorComponent } from "./components/infrastructure/carga-error/carga-error.component";
import { CargaFundoErrorComponent } from "./components/infrastructure/carga-fundo-error/carga-fundo-error.component";
import { CargaGestorErrorComponent } from "./components/infrastructure/carga-gestor-error/carga-gestor-error.component";
import { CargaLastroErrorComponent } from "./components/infrastructure/carga-lastro-error/carga-lastro-error.component";
import { CompromissadaErrorComponent } from "./components/infrastructure/compromissada-error/compromissada-error.component";
import { ConfirmationDialogComponent } from "./components/infrastructure/confirmation-dialog/confirmation-dialog.component";
import { CotaErrorComponent } from "./components/infrastructure/cota-error/cota-error.component";
import { DespesasErrorComponent } from "./components/infrastructure/despesas-error/despesas-error.component";
import { EletronicTransferReleasesDialogComponent } from "./components/infrastructure/eletronic-transfer-releases-dialog/eletronic-transfer-releases-dialog.component";
import { EletronicTransferStatementDialogComponent } from "./components/infrastructure/eletronic-transfer-statement-dialog/eletronic-transfer-statement-dialog.component";
import { EmprestimoErrorComponent } from "./components/infrastructure/emprestimo-error/emprestimo-error.component";
import { ExpandableExampleComponent } from "./components/infrastructure/expandable-example/expandable-example";
import { FundoInvComponent } from "./components/infrastructure/fundo-inv-error/fundo-inv-error.component";
import { FuturosErrorComponent } from "./components/infrastructure/futuros-error/futuros-error.component";
import { InformDialogComponent } from "./components/infrastructure/inform-dialog/inform-dialog.component";
import { MargemErrorComponent } from "./components/infrastructure/margem-error/margem-error.component";
import { ModalCargaErrorComponent } from "./components/infrastructure/modal-carga-error/modal-carga-error";
import { ModalErrorComponent } from "./components/infrastructure/modal-error/modal-error";
import { ModalFileComponent } from "./components/infrastructure/modal-file/modal-file";
import { OperationStructuredCommentDialogComponent } from "./components/infrastructure/operation-structured-comment-dialog/operation-structured-comment-dialog.component";
import { OperationStructuredPrecedentDialogComponent } from "./components/infrastructure/operation-structured-precedent-dialog/operation-structured-precedent-dialog.component";
import { OperationStructuredReservationDialogComponent } from "./components/infrastructure/operation-structured-reservation-dialog/operation-structured-reservation-dialog.component";
import { PassivosErrorComponent } from "./components/infrastructure/passivos-error/passivos-error.component";
import { RadioListComponent } from "./components/infrastructure/radio-list/radio-list.component";
import { RejectDialogComponent } from "./components/infrastructure/reject-dialog/reject-dialog.component";
import { RfPrivadoErrorComponent } from "./components/infrastructure/rf-privado-error/rf-privado-error.component";
import { RfPublicoErrorComponent } from "./components/infrastructure/rf-publico-error/rf-publico-error.component";
import { SwapCetipErrorComponent } from "./components/infrastructure/swap-cetip-error/swap-cetip-error.component";
import { TermoMoedaErrorComponent } from "./components/infrastructure/termo-moeda-error/termo-moeda-error.component";
import { TransferenciaErrorComponent } from "./components/infrastructure/transferencia-error/transferencia-error.component";
import { ValidationSummaryComponent } from "./components/infrastructure/validation-summary/validation-summary.component";
import { WarningGroupDialogComponent } from "./components/infrastructure/warning-group-dialog/warning-group.component";
import { LiabilitiesComponent } from "./components/liabilities/liabilities.component";
import { LimitHoursComponent } from "./components/limit-hours/limit-hours.component";
import { LoanComponent } from "./components/loan/loan.component";
import { MargemComponent } from "./components/margem/margem.component";
import { MonitorGeralComponent } from "./components/monitor-geral/monitor-geral.component";
import { MonitorArquivosComponent } from "./components/monitor-recebiveis/monitor-arquivos.component";
import { MonitorExtratoDialogComponent } from "./components/monitor-recebiveis/monitor-extrato-dialog.component";
import { MonitorRecebiveisComponent } from "./components/monitor-recebiveis/monitor-recebiveis.component";
import { MonitoresComponent } from "./components/monitores/monitores.component";
import { NavBarComponent } from "./components/nav-bar/nav-bar.component";
import { NavMenuComponent } from "./components/nav-menu/nav-menu.component";
import { ObterCargasComponent } from "./components/obter-cargas/obter-cargas.component";
import { FileListTableComponent } from "./components/operation-structured/file-list-table/file-list-table.component";
import { OperationStructuredComponent } from "./components/operation-structured/operation-structured.component";
import { OrdemOperacaoEstruturadaListaComponent } from "./components/ordem-operacao-estruturada-lista/ordem-operacao-estruturada-lista.component";
import { OrdemOperacaoEstruturadaComponent } from "./components/ordem-operacao-estruturada/ordem-operacao-estruturada.component";
import { OutCustodyComponent } from "./components/out-custody/out-custody.component";
import { OutstandingMonitorComponent } from "./components/outstanding-monitor/outstanding-monitor.component";
import { PaginadorComponent } from "./components/paginador/paginador.component";
import { KeysPipe } from "./components/pipe-error/keys-pipe";
import { PipeErrorComponent } from "./components/pipe-error/pipe-error";
import { ReleasesComponent } from "./components/releases/releases.component";
import { BoletaRendaVariavelComponent } from "./components/renda-variavel/renda-variavel.component";
import { ReportUploadComponent } from "./components/report-upload/report-upload.component";
import { RendaVariavelComponent } from "./components/rv/rv.component";
import { SelicComponent } from "./components/selic/selic.component";
import { StockFundsComponent } from "./components/stock-funds/stock-funds.component";
import { SwapCetipComponent } from "./components/swap-cetip/swap-cetip.component";
import { TabelaHistoricoBoletaComponent } from "./components/tabela-historico-boleta/tabela-historico-boleta.component";
import { TabelaHistoricoCargaComponent } from "./components/tabela-historico-carga/tabela-historico-carga.component";
import { TermoMoedaComponent } from "./components/termo-moeda/termo-moeda.component";
import { TransferStatusComponent } from "./components/transfer-status/transfer-status.component";
import { TransferComponent } from "./components/transfer/transfer.component";
import { TypesComponent } from "./components/types/types.component";
import { UploadCargaComponent } from "./components/upload-carga/upload-carga.component";
import { UploadRvComponent } from "./components/upload-rv/upload-rv.component";
import { UploadTicketComponent } from "./components/upload-ticket/upload-ticket.component";
import { UploadTransferOrdeComponent } from "./components/upload-to/upload-to.component";
import { UploadWfHistoryComponent } from "./components/upload-to/upload-wf-history.component";
import { UsuariosComponent } from "./components/usuarios/usuarios.component";
import { WalletComponent } from "./components/wallet/wallet.component";
import { WorkflowHistoryComponent } from "./components/workflow-history/workflow-history.component";
import { DebounceClickDirective } from "./debounce-click.directive";
import { Interceptor } from "./interceptor.module";
import { TicketTransferStatusPipe } from "./pipes/eletronic-transfer-status.pipe";
import { TicketTypePipe } from "./pipes/ticket-type.pipe";
import { BankService } from "./services/bank.service";
import { Counterpartservice } from "./services/counterpart.service";
import { CutoffService } from "./services/cutoff.service";
import { LoaderService } from "./services/loader.service";
import { SnackbarService } from "./services/snackbar.service";

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#E9463A",
  bgsOpacity: 0.5,
  bgsPosition: "bottom-right",
  bgsSize: 60,
  bgsType: "ball-scale-multiple",
  fgsColor: "#E9463A",
  fgsPosition: "center-center",
  fgsSize: 60,
  fgsType: "ball-scale-multiple",
  pbColor: "#FF0000",
  pbDirection: "ltr",
  pbThickness: 5,
  textColor: "#FFFFFF",
  textPosition: "center-center",
  hasProgressBar: false,
};

@NgModule({
  declarations: [
    TabelaHistoricoCargaComponent,
    TabelaHistoricoBoletaComponent,
    PassivosErrorComponent,
    DespesasErrorComponent,
    CambioErrorComponent,
    EmprestimoErrorComponent,
    TransferenciaErrorComponent,
    TermoMoedaErrorComponent,
    MargemErrorComponent,
    SwapCetipErrorComponent,
    FuturosErrorComponent,
    CompromissadaErrorComponent,
    RfPublicoErrorComponent,
    RfPrivadoErrorComponent,
    CotaErrorComponent,
    AppComponent,
    NavMenuComponent,
    NavBarComponent,
    HomeComponent,
    CotaComponent,
    CetipComponent,
    SelicComponent,
    MargemComponent,
    CompromissadaCompraComponent,
    TermoMoedaComponent,
    RendaVariavelComponent,
    SwapCetipComponent,
    BankComponent,
    DashboardComponent,
    DadosBoletaComponent,
    DadosFundoComponent,
    RadioListComponent,
    TypesComponent,
    MonitorGeralComponent,
    MonitoresComponent,
    OutstandingMonitorComponent,
    FuturosComponent,
    ValidationSummaryComponent,
    ConfirmationDialogComponent,
    UploadWfHistoryComponent,
    EletronicTransferStatementDialogComponent,
    EletronicTransferReleasesDialogComponent,
    DebounceClickDirective,
    LoginComponent,
    ExpandableExampleComponent,
    CadastroUsuarioComponent,
    GruposComponent,
    CadastroGrupoComponent,
    UsuariosComponent,
    UploadRvComponent,
    UploadTicketComponent,
    UploadCargaComponent,
    WorkflowHistoryComponent,
    LimitHoursComponent,
    RejectDialogComponent,
    InformDialogComponent,
    FooterComponent,
    PasswordResetComponent,
    EsqueciSenhaComponent,
    PaginadorComponent,
    MonitorRecebiveisComponent,
    MonitorArquivosComponent,
    MonitorExtratoDialogComponent,
    AnnotationComponent,
    CutoffComponent,
    CutoffCreateComponent,
    CutoffDefaultUpdateComponent,
    CutoffDefaultManagerFundDialogComponent,
    CutoffExceptionHistoryComponent,
    TicketTypePipe,
    UploadTransferOrdeComponent,
    TransferComponent,
    LoanComponent,
    ExchangeComponent,
    BoletaRendaVariavelComponent,
    OutCustodyComponent,
    ReleasesComponent,
    AttachmentComponent,
    AdminFiduciProofComponent,
    TicketTransferStatusPipe,
    ExpensesComponent,
    LiabilitiesComponent,
    CalendarioComponent,
    ModalErrorComponent,
    KeysPipe,
    PipeErrorComponent,
    CargaErrorComponent,
    ModalCargaErrorComponent,
    CargaLastroErrorComponent,
    CargaGestorErrorComponent,
    CargaFundoErrorComponent,
    FundoInvComponent,
    OrdemOperacaoEstruturadaComponent,
    OrdemOperacaoEstruturadaListaComponent,
    OperationStructuredComponent,
    OperationStructuredReservationDialogComponent,
    OperationStructuredCommentDialogComponent,
    OperationStructuredReservationDialogComponent,
    OperationStructuredPrecedentDialogComponent,
    ObterCargasComponent,
    CounterpartListComponent,
    CounterpartRegisterComponent,
    WarningGroupDialogComponent,
    TransferStatusComponent,
    CounterpartComponent,
    ExpenseTypeComponent,
    StockFundsComponent,
    FavoredComponent,
    ModalFileComponent,
    WalletComponent,
    BatchEmailComponent,
    BankListComponent,
    BankRegisterComponent,
    FileListTableComponent,
    ReportUploadComponent,
  ],
  imports: [
    PdfViewerModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    MatButtonModule,
    MatCardModule,
    CommonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatToolbarModule,
    MatAutocompleteModule,
    TextMaskModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forRoot(NgxMaskModule_options),
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: "danger", // set defaults here
    }),
    NgxUiLoaderRouterModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    Interceptor,
    NgSelectModule,
    RouterModule.forChild([{ path: "", component: ReleasesComponent }]),
    MarkdownModule.forRoot({ loader: HttpClient }),
    FontAwesomeModule,
    ModalModule.forRoot(),
    QuillModule.forRoot(),
    QRCodeModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    DatePipe,
    DecimalPipe,
    { provide: LOCALE_ID, useValue: "pt-BR" },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
    { provide: MAT_DIALOG_DATA, useValue: null },
    LoaderService,
    SnackbarService,
    CutoffService,
    BankService,
    Counterpartservice,
    CookieService,
    BsModalService,
  ],
  bootstrap: [AppComponent],
  exports: [],
  entryComponents: [
    ConfirmationDialogComponent,
    RejectDialogComponent,
    MonitorExtratoDialogComponent,
    InformDialogComponent,
    UploadWfHistoryComponent,
    EletronicTransferStatementDialogComponent,
    EletronicTransferReleasesDialogComponent,
    CutoffDefaultManagerFundDialogComponent,
  ],
})
export class AppModule {}
